
























































import { FabricSwatch } from "@/models/products/fabric";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Swatch extends Vue {
  @Prop() img!: string | null;
  @Prop() discontinued!: boolean | null;
  @Prop() comparisons!: FabricSwatch["comparisons"];
  /** Manufacturer handle string (e.g. "recasens", "sunbrella") passed from the parent. */
  @Prop() mfr_handle!: string | null;

  get cdnUrl(): string {
    return process.env.VUE_APP_CDN_URL + "/fabric_swatches/";
  }

  /**
   * Only show the comparison feature on fabrics that have a Recasens comparison,
   * not on the comparable Recasens fabrics themselves.
   */
  get filteredComparisons(): string[] | FabricSwatch[] {
    return this.mfr_handle?.toLocaleLowerCase() === "recasens" ||
      !this.comparisons
      ? []
      : this.comparisons;
  }
}
